import { useEffect, useState } from 'react'
import { useUrlFilters } from 'src/libs/useUrlFilters'
import { FILTER_CONFIG_EX_DIFFERENCE } from 'src/pages/finSystem/balanceSummary/reports/const'
import { getPeriodByRange } from 'src/pages/finSystem/balanceSummary/reports/utils'
import { FormValue } from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/types'
import { exDifferenceListLoad } from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/model'
import {
  ExDifferenceListFilter,
  ExDifferenceListTable,
} from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/components'
import { SortDirectionT } from 'src/pages/finSystem/balanceSummary/reports/types'
import dayjs from 'dayjs'

export const ExDifferenceListSection = () => {
  const { filters, setFilters } = useUrlFilters(FILTER_CONFIG_EX_DIFFERENCE)
  const { dateFrom, dateTo, currencies, walletIds, sorterField } = filters
  const [sortDirection, setSortDirection] = useState<SortDirectionT>('descend')

  const getInitialValueForm = () => {
    const result: FormValue = {}

    const period = getPeriodByRange(dateFrom, dateTo)
    result['period'] = period

    result['periodDatePicker'] =
      period === 'date_range' ? [dayjs(dateFrom), dayjs(dateTo)] : undefined

    result['currencies'] = currencies
    result['walletIds'] = walletIds

    return result
  }

  const resetFilters = () => {
    setFilters({ currencies: undefined, walletIds: undefined })
    setSortDirection(undefined)
  }

  useEffect(() => {
    exDifferenceListLoad({
      dateFrom,
      dateTo,
      currencies,
      sorterField,
      walletIds: walletIds ?? [],
    })
  }, [dateFrom, dateTo, currencies, walletIds, sorterField])

  return (
    <>
      <ExDifferenceListFilter
        filters={filters}
        setFilters={setFilters}
        resetFilters={resetFilters}
        initialValueForm={getInitialValueForm()}
      />
      <br />
      <ExDifferenceListTable
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        setFilters={setFilters}
      />
    </>
  )
}
